import { trpc } from "../trpc";

interface Input {
  folderId?: string;
  enabled?: boolean;
}

export function useFolderById({ folderId, enabled = true }: Input) {
  const query = trpc.folder.getById.useQuery(
    { folderId: folderId ?? "" },
    { enabled: !!folderId && enabled },
  );

  return {
    folder: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
